import type { ColumnDataType } from "../../schema/chart.js";

export function toNumber(raw: string): number {
    const n = Number(raw);
    return isNaN(n) ? 0 : n;
}

export function formatValue(raw: string, dataType: ColumnDataType): string {
    if (raw === "") return "";

    switch (dataType) {
        case "currency": {
            const n = toNumber(raw);
            return n.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
        case "percentage": {
            const n = toNumber(raw);
            return `${n}%`;
        }
        case "duration": {
            const totalSeconds = Math.round(toNumber(raw));
            const h = Math.floor(totalSeconds / 3600);
            const m = Math.floor((totalSeconds % 3600) / 60);
            const s = totalSeconds % 60;
            if (h > 0) return s > 0 ? `${h}h ${m}m ${s}s` : `${h}h ${m}m`;
            if (m > 0) return s > 0 ? `${m}m ${s}s` : `${m}m`;
            return `${s}s`;
        }
        case "date_epoch": {
            const ms = toNumber(raw);
            // If value looks like seconds (< 1e10), convert to ms
            const date = new Date(ms < 1e10 ? ms * 1000 : ms);
            return isNaN(date.getTime()) ? raw : date.toLocaleDateString();
        }
        case "date_iso": {
            const date = new Date(raw);
            return isNaN(date.getTime()) ? raw : date.toLocaleDateString();
        }
        case "rating": {
            const n = Math.round(toNumber(raw));
            const clamped = Math.max(0, Math.min(5, n));
            return "\u2605".repeat(clamped) + "\u2606".repeat(5 - clamped);
        }
        case "boolean": {
            const lower = raw.toLowerCase();
            const truthy = new Set(["true", "t", "yes", "y", "1"]);
            return truthy.has(lower) ? "Yes" : "No";
        }
        case "number": {
            const n = toNumber(raw);
            if (raw === "" || isNaN(Number(raw))) return raw;
            return n.toLocaleString("en-US");
        }
        default:
            return raw;
    }
}
